export class Cost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "amount",
            "baseName": "amount",
            "type": "number",
            "format": "double"
        },
        {
            "name": "unit",
            "baseName": "unit",
            "type": "CostUnit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Cost.attributeTypeMap;
    }
    constructor() {
    }
}
